import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;

  color: #000000;
`;

export const DayWrapper = styled.div`
  inline-size: 36px;

  color: #000000;
  font-family: ${fontRoboto};
  text-align: center;
`;

export const Date = styled.div`
  font-size: 28px;
  line-height: 33px;
`;

export const Month = styled.div`
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
`;

export const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 28px;
  font-family: ${fontRobotoCondensed};
  line-height: 33px;
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row wrap;
  gap: 8px;
  align-items: center;

  block-size: 16px;

  color: #333333;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 14px;
`;

export const DateRange = styled.div`
  font-weight: 700;
  white-space: nowrap;
`;

export const Time = styled.div`
  white-space: nowrap;
`;

export const SecondaryDescription = styled.div``;

export const Separator = styled.div`
  font-weight: 700;
`;
